export const NavbarIcon: React.FC<React.SVGAttributes<{}>> = (props) => (

	<svg height="24" viewBox="0 0 24 24" width="24" {...props} focusable="false" >
	<path d="M21 6H3V5h18v1zm0 5H3v1h18v-1zm0 6H3v1h18v-1z"></path></svg>
);
